import React, { createElement } from 'react';
import PropTypes from 'prop-types';
import { fromJS } from 'immutable';

import pngImages from '../../../Icons/png';

export const Step1 = ({ surveys, icons, setSurvey, survey: currentSurvey }) => {
  const renderHTML = rawHTML => createElement('div', { dangerouslySetInnerHTML: { __html: rawHTML } });

  const getIcon = survey => {
    let iconName = survey.get('iconName');

    const iconXml = icons.getIn([iconName]);

    if (iconXml) {
      return renderHTML(decodeURIComponent(iconXml));
    }

    let path = iconName;
    if (!iconName?.startsWith('http')) {
      const iconMap = new Map([
        [['loan-family', 'emprunteur.png'], 'emprunteur.png'],
        [['coopengo-address', 'homme_cle.png'], 'homme_cle.png'],
        [['insurer', 'protection_personnelle.png'], 'protection_personnelle.png'],
        [['croisee.png'], 'croisee.png'],
        [['protection_professionnels.png'], 'protection_professionnels.png'],
      ]);

      for (const [keys, value] of iconMap) {
        if (keys.includes(iconName)) {
          iconName = value;
          break;
        }
      }
      path = pngImages[iconName];
    }
    return <img className="img-icon" src={path} alt={survey.get('icon')} />;
  };

  const onClickHandler = id => {
    setSurvey(id);
  };

  const onKeyPressHandler = id => {
    setSurvey(id);
  };

  const classBlock = id => `survey-block${currentSurvey === id ? ' selected' : ''} `;

  const surveyMap = surveys.toArray();

  return (
    <div className="step step1">
      {surveyMap.map((survey, index) => (
        <div
          className={classBlock(survey.get('id'))}
          role="button"
          tabIndex={index}
          // eslint-disable-next-line react/no-array-index-key
          key={`${survey.get('id')}-${index}`}
          onClick={() => onClickHandler(survey.get('id'))}
          onKeyPress={() => onKeyPressHandler(survey.get('id'))}
        >
          <div className="survey-label">{survey.get('name')}</div>
          <div className="survey-icon">{getIcon(survey)}</div>
        </div>
      ))}
    </div>
  );
};

Step1.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  surveys: PropTypes.object,
  // eslint-disable-next-line react/forbid-prop-types
  icons: PropTypes.object,
  setSurvey: PropTypes.func,
  // eslint-disable-next-line react/forbid-prop-types
  survey: PropTypes.any,
};

Step1.defaultProps = {
  surveys: fromJS({}),
  icons: fromJS([]),
  survey: undefined,
  // eslint-disable-next-line no-console
  setSurvey: params => console.log('setSurvey::', params),
};
